import HorizontalBorders from '@components/shapes/HorizontalBorders'
import VerticalBorders from '@components/shapes/VerticalBorders'
import Slider, { EmblaSlide } from '@components/slider/Slider'
import useMediaQuery, { maxWidthQueries, minWidthQueries } from '@utils/useMediaQuery'
import React from 'react'
import ProgressiveImage from 'react-progressive-image'
import styled, { useTheme } from 'styled-components'

const StyledImage = styled.img`
  position: relative;
  left: 50%;
  top: 50%;

  background-position: bottom;
  height: 100%;
  width: auto;
  transform: translate(-50%, -50%);
  transition: all ease 0.2s;
  filter: ${({ blur }) => (blur ? 'blur(2px)' : '')};
  /*background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};*/
  background-position: center;
  background-size: cover;
  opacity: 0;
`

const Background = styled.div`
  height: 100%;
  min-width: 100%;
  position: absolute;

  top: 0;
  left: 0;
  /* background: url('/images/bg_white_pattern.png');*/
`

const SentiusImgHolder = styled.div`
  max-height: 500px;
  max-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
const Holder = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  position: relative;
  width: 100%;
`

const SentiusShowcase = ({ images, id }) => {
  const theme = useTheme()
  const isLarge = useMediaQuery(minWidthQueries.md)
  return (
    <Holder>
      <Slider
        key={id}
        padding="10px"
        slides={images?.map(image => (
          <ProgressiveImage
            key={image.medium}
            placeholder={image.thumbnail}
            src={isLarge ? image.medium : image.small}
            style={{ width: '100%' }}
          >
            {(src, loading) => (
              <EmblaSlide
                style={{
                  backgroundImage: `url(${src}) `,
                  backgroundPosition: 'bottom',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  borderRadius: '20px',
                  filter: loading ? 'blur(2px)' : '',
                  height: 'auto',
                  width: 'auto',
                }}
              >
                <SentiusImgHolder>
                  <StyledImage
                    alt={image.alternativeText}
                    backgroundImage={theme.images.sentiusPattern}
                    blur={loading}
                    src={src}
                  />
                </SentiusImgHolder>
              </EmblaSlide>
            )}
          </ProgressiveImage>
        ))}
      >
        <VerticalBorders />
        <HorizontalBorders />
      </Slider>
    </Holder>
  )
}

export default SentiusShowcase
